/**
 * 사내망 전용 서비스의 경고 (migration 131, 2026-09-30) — /apps 폰 엔진(apps.js)과 데스크톱 탭 틀
 * (workspace-shell.js)이 함께 쓴다.
 *
 * 서버가 요청 IP 를 관리자가 정한 사내망 대역과 견주어 「밖」이라고 판정했을 때만(대역이 없으면 판정하지 않는다)
 * 그 서비스를 여는 자리에 iframe 대신 안내 카드를 그린다. 「그래도 열기」는 이 탭의 sessionStorage 에 앱별로
 * 기억한다 — VPN 에 붙어 있는데 주소가 사내망 밖으로 보이는 경우, 같은 탭에서는 다시 묻지 않는다.
 *
 * 의존 없음: 탭 틀이 큰 모듈 그래프를 끌어오지 않게 한다.
 */
const ALLOW_KEY = 'apps.offnet.allow';
const ALLOW_MAX = 50;
let seq = 0;

function allowedList() {
    try {
        const v = JSON.parse(sessionStorage.getItem(ALLOW_KEY) || '[]');
        return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
    } catch (_) {
        return [];
    }
}

export function offnetAllowed(id) {
    return !!id && allowedList().includes(id);
}

export function allowOffnet(id) {
    if (!id) return;
    const list = allowedList().filter((x) => x !== id);
    list.push(id);
    try {
        sessionStorage.setItem(ALLOW_KEY, JSON.stringify(list.slice(-ALLOW_MAX)));
    } catch (_) {
        /* 기억하지 못해도 이번 한 번은 열린다 */
    }
}

export function hostOf(url) {
    try {
        return new URL(url).host;
    } catch (_) {
        return '';
    }
}

function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
}

// offnetCard: 안내 카드. className 은 부르는 쪽의 프레임 클래스(.app-frame · .ws-frame)이고 — 그래야 활성·숨김
// 규칙이 iframe 과 똑같이 먹는다 — 이름·주소는 글자로만 넣는다. 단추 둘을 돌려주고 연결은 부르는 쪽이 한다.
// labels: { title, body, open, back }
export function offnetCard({ className, name, url, labels }) {
    const L = labels || {};
    const id = 'offnet-' + (++seq);
    const root = el('div', (className ? className + ' ' : '') + 'offnet-wrap');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-labelledby', id);
    root.tabIndex = -1;
    root.dataset.offnet = '1';
    const card = el('div', 'offnet-card');
    const icon = el('div', 'offnet-icon', '⚠');
    icon.setAttribute('aria-hidden', 'true');
    const title = el('h2', 'offnet-title', L.title || '사내망에서만 접근 가능합니다');
    title.id = id;
    const body = el('p', 'offnet-body', L.body || '지금 접속한 곳은 사내망이 아닙니다.');
    const host = hostOf(url);
    const who = el('p', 'offnet-who');
    who.append(el('strong', '', name || host || ''));
    if (host && host !== name) who.append(el('span', 'offnet-host', ' · ' + host));
    const acts = el('div', 'offnet-actions');
    const back = el('button', 'btn btn-primary offnet-back', L.back || '목록으로');
    back.type = 'button';
    const open = el('button', 'btn btn-secondary offnet-open', L.open || '그래도 열기');
    open.type = 'button';
    open.dataset.offnetOpen = '1';
    acts.append(back, open);
    card.append(icon, title, body, who, acts);
    root.append(card);
    return { root, back, open };
}
